import logo from '../AZWG_Emblem_Transparent.png';

const Home = () => {
    return (
    <div style={{
        margin: 0,
        /* Subtracts the height of your navbar (adjust '60px' to match your navbar's actual height) */
        height: 'calc(100vh - 60px)', 
        display: 'flex',
        flexDirection: 'column',   
        justifyContent: 'center',  
        alignItems: 'center',      
        boxSizing: 'border-box',
        gap: '20px',
        overflow: 'hidden'         /* Safety net to prevent internal element overflow */
    }}>
        <img
            alt="Airman's Attic Logo"
            src={logo}
            style={{
                maxWidth: '200px', 
                height: 'auto'     
            }}
        />
        <h1 style={{ margin: 0 }}>    
            Airman's Attic
        </h1>
    </div>
    )
}

export default Home;
